import { render, staticRenderFns } from "./FilesDetail.vue?vue&type=template&id=079bb634&scoped=true&"
import script from "./FilesDetail.vue?vue&type=script&lang=js&"
export * from "./FilesDetail.vue?vue&type=script&lang=js&"
import style0 from "./FilesDetail.vue?vue&type=style&index=0&id=079bb634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079bb634",
  null
  
)

export default component.exports